import { z } from 'zod'
import type { ValidateMapDeploymentsResult } from '@/features/filteredMap/mapDeployments/fetchMapDeployments'
import {
	baseMapDeploymentSchema,
	type ServerReceivedMapDeployments,
	serverReceivedMapDeploymentsSchema,
} from '@/features/filteredMap/mapDeployments/models'

const enablementInstanceSchema = baseMapDeploymentSchema.extend({
	channelPartner: z.string(), // or empty string '' if not applicable
	provider: z.string(),
	marketPenetration: z.number().min(0).max(100),
	accreditation: z.array(z.string()), // array of strings ['Certified','Accredited']
	liveDate: z.iso.date(), // ISO 8601 https://zod.dev/api#iso-dates -> ✅ 2026-01-21
	link: z.nullable(z.string()), // Allow URL or empty string
	status: z.enum(['live', 'pending']),
})

export type EnablementMapDeployment = z.infer<typeof enablementInstanceSchema>
export type ServerReceivedEnablementMapDeployment =
	ServerReceivedMapDeployments<EnablementMapDeployment>

export function validateServerReceivedEnablementMapDeployment(
	unvalidatedData: ServerReceivedMapDeployments<EnablementMapDeployment>
): ValidateMapDeploymentsResult<EnablementMapDeployment> {
	const { data, error } = serverReceivedMapDeploymentsSchema(
		enablementInstanceSchema
	).safeParse(unvalidatedData)
	if (error) {
		const pretty = z.prettifyError(error)
		return {
			success: false,
			message: `Error parsing ServerReceivedEnablementMapDeployment: ${pretty}`,
		}
	}
	return {
		success: true,
		data,
	}
}
